import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const integrationsMenuWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
